<template>
  <div v-if="contractDetail">
    <div class="header">合同基本信息</div>
    <div class="detail" >
      <p class="title">{{ contractDetail.name }}</p>
      <p>合同金额: <span class="currency">￥{{ contractDetail.amount.toLocaleString() }}</span></p>
      <p>公司名称: {{ contractDetail.companyName }}</p>
      <p>合同性质: {{ contractDetail.type }}</p>
      <p>合同类型: {{ contractDetail.category }}</p>
      <p>引进人: {{ contractDetail.referrer }}</p>
      <p>付款方式: {{ payType }}</p>
      <p>签约日期: {{ contractDetail.signedDate }}</p>
      <p>付款截至日期: {{ contractDetail.payDue }}</p>
      <p>合同日期: {{ contractDetail.startDate }} ~ {{ contractDetail.endDate }}</p>
      <p>负责代理: {{ contractDetail.proxy }}</p>
    </div>
    <div class="header">合同相关信息</div>
    <div class="detail">
      <p>甲方经办人: {{ contractDetail.operator1 }}</p>
      <p>乙方经办人: {{ contractDetail.operator2 }}</p>
      <p>甲方签字人: {{ contractDetail.signatureName1 }}</p>
      <p>乙方签字人: {{ contractDetail.signatureName2 }}</p>
      <p>甲方盖章签字: {{ contractDetail.signatureCompany1 }}</p>
      <p>乙方盖章签字: {{ contractDetail.signatureCompany2 }}</p>
      <p>备注: {{ contractDetail.notes }}</p>
      <p>合同扫描件:<a v-if="contractDetail.documentFileName" :href="url">查看</a></p>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';

  export default {
    name: "ContractDetail",
    computed:{
      ...mapGetters(['contractDetail']),
      id(){
        return this.$route.params.contractId
      },
      url(){

        if(this.contractDetail.documentFileName){
          let type = '';
          let index = this.contractDetail.documentFileName.lastIndexOf(".");
          let suffix = this.contractDetail.documentFileName.substr(index + 1);

          if (suffix === 'jpg' || suffix === 'jpeg') {
            type = 'image';
          } else if (suffix === 'xls' || suffix === 'xlsx') {
            type = 'excel'
          } else if (suffix === 'pdf') {
            type = 'pdf';
          }

          return `/preview.html?type=${type}&url=${process.env.VUE_APP_API}assets/${this.contractDetail.documentInternalName}`;
        }else{
          return '';
        }

      },
      payType(){
        switch (this.contractDetail.payType) {
          case 0:
            return '一次性';
          case 3:
            return '3个月';
          case 6:
            return '6个月';
          case 12:
            return '12个月';
          default:
            return '';
        }
      }
    },
    methods:{
      ...mapActions(['getContractDetail']),
    },
    created() {
      this.getContractDetail(this.id);
    }
  }
</script>

<style scoped>
  .header{
    background: #F2F2F2;
    height: 40px;
    padding:0 26px;
    line-height: 40px;
    font-size: 14px;
    font-weight: bold;
  }
  .detail{
    padding:10px 26px;
    font-size: 14px;
    line-height: 28px;
  }
  .detail .title{
    font-size: 16px;
    font-weight: bold;
  }
  .detail .currency{
    font-size: 18px;
    color:#FD493A;
  }
</style>
